// Carrier logos (Wikipedia/Wikimedia brand assets, 512px PNG thumbnails in
// src/assets/carrier-logos). Matching is keyword-based on the normalized
// name so tenant variants ("DHL Express 24h", "Colissimo (La Poste)",
// "DPD MONDE") resolve to the right brand; order matters — most specific
// keywords first. Carriers without a known logo return null and callers
// fall back to the generic chip.
import amazonLogo from '../assets/carrier-logos/amazon.png';
import bpostLogo from '../assets/carrier-logos/bpost.png';
import chronopostLogo from '../assets/carrier-logos/chronopost.png';
import colisPriveLogo from '../assets/carrier-logos/colis-prive.png';
import colissimoLogo from '../assets/carrier-logos/colissimo.png';
import dhlLogo from '../assets/carrier-logos/dhl.png';
import dpdLogo from '../assets/carrier-logos/dpd.png';
import fedexLogo from '../assets/carrier-logos/fedex.png';
import geodisLogo from '../assets/carrier-logos/geodis.png';
import glsLogo from '../assets/carrier-logos/gls.png';
import laPosteLogo from '../assets/carrier-logos/la-poste.png';
import mondialRelayLogo from '../assets/carrier-logos/mondial-relay.png';
import sdaLogo from '../assets/carrier-logos/sda.png';
import tntLogo from '../assets/carrier-logos/tnt.png';
import upsLogo from '../assets/carrier-logos/ups.png';

const LOGO_RULES = [
  [['mondial relay', 'mondialrelay', 'inpost'], mondialRelayLogo],
  [['colis prive', 'colisprive', 'colis-prive'], colisPriveLogo],
  [['colissimo', 'coliposte'], colissimoLogo],
  [['chronopost', 'chrono relais', 'chrono express', 'chrono classic'], chronopostLogo],
  [['dhl', 'deutsche post'], dhlLogo],
  [['dpd'], dpdLogo],
  [['gls', 'general logistics'], glsLogo],
  [['fedex'], fedexLogo],
  [['tnt'], tntLogo],
  [['ups', 'united parcel'], upsLogo],
  [['bpost'], bpostLogo],
  [['geodis', 'france express'], geodisLogo],
  [['sda'], sdaLogo],
  [['amazon'], amazonLogo],
  [['delivengo', 'la poste', 'laposte', 'lettre suivie', 'lettre verte'], laPosteLogo],
];

const normalizeCarrierName = (name) =>
  String(name || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export function getCarrierLogo(name) {
  const normalized = normalizeCarrierName(name);
  if (!normalized) return null;
  for (const [keywords, logo] of LOGO_RULES) {
    if (keywords.some((keyword) => normalized.includes(keyword))) return logo;
  }
  return null;
}

export default getCarrierLogo;
